<template>
  <div class="p-company-wizard-step">
    <div class="p-company-wizard-step__card">
      <text-card
        :title="$t('wizard.company.text-card.title')"
        :text="$t('wizard.company.text-card.text')"
        image="protect-whitelabel"
      />
    </div>
    <div class="p-company-wizard-step__card">
      <card
        :title="title"
        :description="$t('wizard.company.description')"
      >
        <div class="p-company-wizard-step-card">
          <div class="p-company-wizard-step-card__form">
            <company-form
              ref="form"
              :value="formValue"
              @input="handleFormValueChange"
            />
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { setAutoFocus } from '@/app/library/setAutoFocus';
import Card from '@/app/components/Card';
import TextCard from '@/app/components/TextCard';
import CompanyForm from '@/app/components/CompanyForm';

export default {
  name: 'CompanyWizardStep',
  components: {
    Card,
    TextCard,
    CompanyForm
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    stepIndex: {
      type: Number,
      required: true
    }
  },
  emits: [
    'input'
  ],
  data() {
    return {
      formValue: this.getDefaultFormValue()
    };
  },
  computed: {
    title() {
      return `${this.stepIndex}. ${this.$t('wizard.company.title')}`;
    }
  },
  created() {
    this.setFormValue(this.value);
  },
  async mounted() {
    await this.$nextTick();
    setAutoFocus(this.$el);
    this.$refs.form.clearValidate();
  },
  methods: {
    handleFormValueChange(value) {
      this.$emit('input', value);
    },
    getDefaultFormValue() {
      return {
        officialName: '',
        country: '',
        state: '',
        zipCode: ''
      };
    },
    setFormValue(value) {
      this.formValue = {
        ...this.formValue,
        ...value
      };
    },
    validate() {
      return this.$refs.form.validate();
    }
  }
};
</script>

<style lang="scss" scoped>
.p-company-wizard-step {
  padding: 24px;

  &__card {
    max-width: 832px;
    margin: 0 auto 16px auto;

    &:last-child {
      margin: 0 auto;
    }
  }
}

.p-company-wizard-step-card {
  &__form {
    padding: 24px 24px 0 24px;
  }
}
</style>
